import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const tomos = [{
  num: '1',
  title: 'Salud Mental en la Consulta Pediátrica',
  desc: 'Cómo detectar señales de salud mental en la consulta de rutina + herramientas de screening rápido + cuándo es normal y cuándo no + plantillas de evaluación listas para completar.',
  image: 'https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?auto=format&fit=crop&w=900&h=300&q=70'
}, {
  num: '2',
  title: 'TDAH, TEA y Trastornos del Desarrollo',
  desc: 'Protocolos de evaluación inicial, diagnóstico diferencial básico, comunicación efectiva con la familia y derivación documentada.',
  image: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?auto=format&fit=crop&w=900&h=300&q=70'
}, {
  num: '3',
  title: 'Abuso Infantil: Detección y Denuncia',
  desc: 'Indicadores físicos y conductuales, cómo entrevistar sin contaminar el relato, y el paso a paso legal para la denuncia obligatoria.',
  image: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=900&h=300&q=70'
}, {
  num: '4',
  title: 'Crisis Emocionales y Conductuales',
  desc: 'Manejo de desbordes en el consultorio, autolesiones, riesgo suicida adolescente y contención familiar inmediata.',
  image: 'https://images.unsplash.com/photo-1559757175-5700dde675bc?auto=format&fit=crop&w=900&h=300&q=70'
}, {
  num: '5',
  title: 'El Escudo Legal del Pediatra',
  desc: 'Consentimiento informado en menores, responsabilidad médica, ley 26.061 aplicada y cómo blindar tu historia clínica.',
  image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&w=900&h=300&q=70'
}, {
  num: '6',
  title: 'Comunicación con Padres y Red Institucional',
  desc: 'Scripts para conversaciones difíciles, coordinación con escuelas y redacción de informes para juzgados de familia.',
  image: 'https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&w=900&h=300&q=70'
}];
export function ContentTomos() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-slate-50 py-8 sm:py-28" data-id="element-83">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-84">
        <div className="text-center max-w-3xl mx-auto mb-5 sm:mb-16" data-id="element-85">
          <h2 className="text-[10px] sm:text-sm font-semibold tracking-wide text-blue-600 uppercase mb-1.5 sm:mb-3" data-id="element-86">
            CONTENIDO COMPLETO
          </h2>
          <p className="text-xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-2 sm:mb-4" data-id="element-87">
            LOS 6 TOMOS
          </p>
          <p className="text-xs sm:text-lg text-slate-600" data-id="element-88">
            Tu hoja de ruta clínica y legal para cualquier situación de salud
            mental en la consulta pediátrica
          </p>
        </div>

        <div className="space-y-2 sm:space-y-4" data-id="element-89">
          {tomos.map((tomo, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className={`rounded-xl sm:rounded-2xl overflow-hidden ring-1 transition-all bg-white ${isOpen ? 'ring-blue-200 shadow-md' : 'ring-slate-200 shadow-sm'}`} data-id="element-90">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="relative block w-full aspect-[3/1] overflow-hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 group" data-id="element-91">
                  <img src={tomo.image} alt={tomo.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-92" />
                  <div className="absolute inset-0 bg-gradient-to-r from-slate-900/85 via-slate-900/60 to-slate-900/30" data-id="element-93"></div>
                  <div className="absolute inset-0 flex items-center gap-2 sm:gap-4 px-3 sm:px-6" data-id="element-94">
                    <div className="flex-shrink-0 w-8 h-8 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl bg-white/15 backdrop-blur-sm text-white flex items-center justify-center font-bold text-sm sm:text-xl ring-1 ring-white/30" data-id="element-95">
                      {tomo.num}
                    </div>
                    <div className="text-left min-w-0" data-id="element-96">
                      <p className="text-[8px] sm:text-xs font-semibold text-teal-300 uppercase tracking-wider" data-id="element-97">
                        Tomo {tomo.num}
                      </p>
                      <h3 className="text-xs sm:text-lg font-bold text-white leading-snug" data-id="element-98">
                        {tomo.title}
                      </h3>
                    </div>
                    <ChevronDown className={`ml-auto flex-shrink-0 w-4 h-4 sm:w-6 sm:h-6 text-white transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-99" />
                  </div>
                </button>

                <AnimatePresence data-id="element-100">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} className="overflow-hidden" data-id="element-101">
                      <p className="px-3 sm:px-6 py-3 sm:py-5 text-[10px] sm:text-base text-slate-600 leading-relaxed" data-id="element-102">
                        {tomo.desc}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}